import { render, staticRenderFns } from "./AddSchoolContact.vue?vue&type=template&id=45aff809&scoped=true&"
import script from "./AddSchoolContact.vue?vue&type=script&lang=js&"
export * from "./AddSchoolContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45aff809",
  null
  
)

export default component.exports